import { getStore } from '@/store'
import { isSameDate, isStandardDeliveryDate } from '@/utils/deliveryDate'

export function setDeliveryDate (date: string, shipmentId: string): void {
  localStorage.setItem('deliveryDate', date)
  const exceptions = getStore()?.state.deliveryDates.availableExceptions
  localStorage.setItem('exceptiondate', Number(exceptions?.some((exception) => isSameDate(exception.scheduledDate, date))).toString())
  localStorage.setItem(
    'standardDeliveryDate',
    Number(isStandardDeliveryDate(date, shipmentId, getStore()?.state.catalog.shipTos)).toString()
  )
}

export function getShipToOptions (): {label: string, shipToId: string, description: string}[] {
  const { permissionSchema = [] } = getStore()?.state.auth.user || {}
  return permissionSchema
    .filter((permission: any) =>
      permission.rpDetails.some(
        (role: any) =>
          role.permission.includes('Catalogue') &&
          permission.shipToStatus === 'APPROVED'
      )
    )
    .map((permission: any) => ({
      label: permission.shipToName,
      shipToId: permission.shipToId,
      description: permission?.shipToAddress
    }))
}
